/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The type of the field.
 */
export const CustomFieldRequestType = {
  Text: "text",
  Checkbox: "checkbox",
} as const;
/**
 * The type of the field.
 */
export type CustomFieldRequestType = ClosedEnum<typeof CustomFieldRequestType>;

/** @internal */
export const CustomFieldRequestType$inboundSchema: z.ZodNativeEnum<
  typeof CustomFieldRequestType
> = z.nativeEnum(CustomFieldRequestType);
/** @internal */
export const CustomFieldRequestType$outboundSchema: z.ZodNativeEnum<
  typeof CustomFieldRequestType
> = CustomFieldRequestType$inboundSchema;
